var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconCaretLeft = function (props) { return (_jsx("span", __assign({ className: "icon icon__caret-left" }, { children: _jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M10.4444 3.60693C10.7538 3.92565 10.7538 4.43268 10.4444 4.75141L7.28995 8L10.4444 11.2486C10.7538 11.5673 10.7538 12.0743 10.4444 12.3931C10.1217 12.7253 9.58833 12.7253 9.2657 12.3931L5.67643 8.69663C5.29967 8.30862 5.29967 7.69138 5.67643 7.30337L9.2657 3.60693C9.58833 3.27466 10.1217 3.27466 10.4444 3.60693Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
